import { getItem } from 'app/components/analytics'

export const trackCreateReturnExchangeItem = (item, orderNumber, locale) => {
    const attributes = {
        exchangeType: item.returnOrExchange,
        returnReason: item.selectedReturnCode
    }

    const { currency, country: countryCode } = locale

    return {
        event: 'refund-exchange - confirm item',
        effect: 'select item for exchange or refund',
        category: {
            primaryCategory: 'ecommerce',
            subCategory: 'my orders'
        },
        attributes: {
            orderNumber,
            orderCurrency: currency,
            countryCode
        },
        return: {
            item: [getItem({ item, attributes })]
        }
    }
}
